import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container-timezone" }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "flex font-size-24 items-end" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mt-2" }, null, -1)
const _hoisted_5 = { class: "mt-8 w-50-custom" }
const _hoisted_6 = { class: "relative mt-1" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", null, null, -1)
const _hoisted_8 = { class: "mt-6 w-50-custom relative" }
const _hoisted_9 = { class: "mt-6 input-text relative" }
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = { class: "flex justify-center" }
const _hoisted_12 = { class: "flex justify-center mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Label = _resolveComponent("Label")
  const _component_Input = _resolveComponent("Input")
  const _component_my_table = _resolveComponent("my-table")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.t('basicSettings')), 1)
    ]),
    _hoisted_4,
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_Label, {
          mandatory: "",
          "text-label": _ctx.t('timezoneDivisionGroupCode')
        }, null, 8, ["text-label"]),
        _createVNode(_component_Input, {
          placeholder: _ctx.t('pleaseEnter'),
          modelValue: _ctx.params.time_zone_session_group_code,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.params.time_zone_session_group_code = $event)),
          errors: _ctx.errors.time_zone_session_group_code,
          "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.time_zone_session_group_code = $event)),
          required: true,
          "error-server": _ctx.listErrorServerReturn.time_zone_session_group_code,
          validated: _ctx.validated
        }, null, 8, ["placeholder", "modelValue", "errors", "error-server", "validated"])
      ]),
      _hoisted_7
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode(_component_Label, {
        mandatory: "",
        "text-label": _ctx.t('timezoneDivisionGroupName')
      }, null, 8, ["text-label"]),
      _createVNode(_component_Input, {
        placeholder: _ctx.t('pleaseEnter'),
        modelValue: _ctx.params.time_zone_session_group_name,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.params.time_zone_session_group_name = $event)),
        errors: _ctx.errors.time_zone_session_group_name,
        "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.time_zone_session_group_name = $event)),
        required: true,
        validated: _ctx.validated,
        "error-server": _ctx.listErrorServerReturn.time_zone_session_group_name
      }, null, 8, ["placeholder", "modelValue", "errors", "validated", "error-server"])
    ]),
    _createVNode("div", _hoisted_9, [
      _createVNode(_component_Label, {
        "text-label": _ctx.t('timezoneDivisionGroupDetails')
      }, null, 8, ["text-label"])
    ]),
    (_openBlock(), _createBlock("div", {
      class: "mt-6",
      key: _ctx.count
    }, [
      _createVNode(_component_my_table, {
        showSelect: "",
        fixedHeader: "",
        class: "w-full max-h-62",
        headers: _ctx.timezoneHeaders,
        "selected-item": _ctx.timezoneDataSelects,
        "onUpdate:selected-item": _cache[5] || (_cache[5] = ($event: any) => (_ctx.timezoneDataSelects = $event)),
        data: _ctx.timezoneData
      }, {
        time_zone_session_type_code: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_10, [
            _createVNode("span", null, _toDisplayString(item.time_zone_session_type_code), 1)
          ])
        ]),
        time_zone_session_type_name: _withCtx(({ item }) => [
          _createVNode("div", _hoisted_11, [
            _createVNode("span", null, _toDisplayString(item.time_zone_session_type_name), 1)
          ])
        ]),
        _: 1
      }, 8, ["headers", "selected-item", "data"])
    ])),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_Button, {
        onClick: _ctx.handleSubmit,
        class: "btn-gradation-light-blue w-50 h-12 mr-20"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('toRegister')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, {
        onClick: _ctx.handleBackToTheList,
        class: "btn-gradation-secondary w-50 h-12"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('backToTheList')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}